import React from 'react';

import styled from 'styled-components';

import Money from '@components/Gui/Money';
import { getDisplayedStatementAmount } from '@components/StatementRowsCommon/helpers';

const AmountDetailsWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
    font-size: ${(props) => props.theme.FontSizeSm};
`;

const renderAmountValue = (row, defaultCurrency) => {
    const displayedAmount = getDisplayedStatementAmount(row, defaultCurrency);

    if (displayedAmount.isConverted) {
        return (
            <div className="total-fee">
                <Money redIfNegative amount={displayedAmount.amount} currency={displayedAmount.currency} />
                <br />
                <Money
                    additionalClassName="original-amount"
                    highlightCurrency
                    redIfNegative
                    amount={displayedAmount.originalAmount}
                    currency={displayedAmount.originalCurrency}
                />
            </div>
        );
    }

    return (
        <div className="total-fee">
            <Money
                highlightCurrency
                redIfNegative
                amount={displayedAmount.amount}
                currency={displayedAmount.currency}
            />
        </div>
    );
};

const renderProjectQuantity = (row) => {
    const transaction = row.Transaction;

    if (transaction?.Quantity === 1 && ['Flat', 'Units'].includes(transaction?.TypeQuantity)) {
        return null;
    }

    return (
        <AmountDetailsWrapper>
            <Money amount={transaction?.SingleFee} currency={transaction?.Currency} />
            <span>
                x {transaction?.Quantity} {transaction?.TypeQuantity}
            </span>
        </AmountDetailsWrapper>
    );
};

const StatementAmountCell = ({
    row,
    defaultCurrency,
    variant = 'billing-search',
    isExpanded = false,
    showJobFeeAmount = false,
}) => {
    if (variant === 'project-grouped') {
        const className = `transaction-right statement-amount-cell${row.isCommission ? ' commission-row' : ''}${
            row.isClientAdvance ? ' advance-row' : ''
        }`;

        return (
            <div className={className}>
                <div className="transaction-fee">
                    {isExpanded && !row.isCommission && renderProjectQuantity(row)}
                    {renderAmountValue(row, defaultCurrency)}
                </div>
            </div>
        );
    }

    const className = `transaction-right statement-amount-cell${row.isCommission ? ' commission-row' : ''}`;
    return (
        <div className={className}>
            <div className="transaction-fee">
                {renderAmountValue(row, defaultCurrency)}
                {showJobFeeAmount &&
                    row.Transaction?.Family === 'JobFee' &&
                    (row.isCommission || row.isClientAdvance) && (
                        <div className="muted-job-fee">
                            JOB FEE AMOUNT: <Money amount={row.JobFeeAmount} currency={row.Transaction?.Currency} />
                        </div>
                    )}
                {showJobFeeAmount &&
                    row.Transaction?.Family === 'JobFee' &&
                    (!row.isCommission || !row.isClientAdvance) &&
                    row.Percentage && (
                        <div className="muted-job-fee">
                            JOB FEE AMOUNT:{' '}
                            <Money amount={row.Transaction?.TotalFee} currency={row.Transaction?.Currency} />
                        </div>
                    )}
            </div>
        </div>
    );
};

export default StatementAmountCell;
